import { gql } from '@apollo/client';

export const TRAINING_PLAN_SESSION_FRAGMENT = gql`
  fragment TrainingPlanSessionFragment on TrainingPlanSession {
    __typename
    _id
    userId
    trainingPlanId
    trainerId
    completed
    completedAt
    enrolledAt
    completedEventCount
    totalEventCount
    status
    completedEvents {
      eventId
      eventSessionId
    }
    trainingPlan {
      __typename
      _id
      title
      status
      trainerId
      coverImageUrl(width: 64, height: 64)
    }
    user {
      _id
      name
      avatarUrl
    }
  }
`;

export const GET_TRAINING_PLAN_SESSIONS = gql`
  query GetTrainingPlanSessionsForTrainingPlan(
    $input: TrainingPlanSessionsQueryInput
  ) {
    trainingPlanSessions(input: $input) {
      ...TrainingPlanSessionFragment
    }
  }
  ${TRAINING_PLAN_SESSION_FRAGMENT}
`;
